<script>
  import SubscriptionSelectionMain from './SubscriptionSelectionMain.svelte';
  import getTranslation from '../../utilities/getTranslation';
  import TextButton from '../TextButton/TextButton.svelte';

  export let data,
    isCustomerInactive = false,
    background = true,
    currentActiveSubscription = null,
    isRTL = false,
    showDarkBackground = false;

  let yScrolled; // This is bound to the window.scrollY at the last line of the file
  let cards = [...new Array(data.firstRow.productGroups.length)].map(() => ({}));
  const oneSubscriptionCard = data.firstRow.productGroups.length <= 1;
  const componentInformationKeys = data.informationKeys;
  let wrapper;

  $: subscriptionData = data
    ? {
        ...data,
        componentInformationKeys,
        isCustomerInactive,
        currentActiveSubscription,
        showDarkBackground,
      }
    : null;

  const topMargin = 150;
  const goToActiveCard = (card) => {
    window.scrollTo({ top: card.wrapper.offsetTop - topMargin, behavior: 'smooth' });
  };

  const getHeight = (card) => Object.values(card).reduce((sum, part) => sum + part.offsetHeight);

  const navHeight = 56;
  const isCardActive = (card, y) => {
    const height = getHeight(card);
    if (card.wrapper) {
      return (
        y + navHeight > card.wrapper.offsetTop - topMargin &&
        y + navHeight < card.wrapper.offsetTop + height - topMargin
      );
    }
  };

  const showNavbar = (wrapper, y) => {
    if (!wrapper) return false;
    const spaceUntilShowNavbar = 100;
    const spaceUntilHideNavbar = 120;
    const height = wrapper.offsetHeight;
    const top = wrapper.offsetTop;
    return y > top - spaceUntilShowNavbar && y < top + height - spaceUntilHideNavbar;
  };
</script>

<style lang="scss">
  @import '../../styles/tools/media-query';
  @import '../../styles/settings/core';
  @import '../../styles/settings/global';
  @import '../../styles/settings/colors';

  nav {
    position: fixed;
    top: 7.9rem;
    z-index: 2;
    width: 100%;

    ul {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      text-align: center;
      padding: 1rem;
      height: spacing(7);
      font-size: spacing(2);
      background-color: $pink-20;
      color: $purple-50;
      font-weight: bolder;
      opacity: 0;
      transition: all 0.2s ease-in;

      &.show {
        opacity: 1;
      }

      li {
        width: 30%;
        cursor: pointer;

        a {
          text-decoration: none;

          &.active {
            border-block-end: 0.2rem solid $purple-50;
            cursor: pointer;
          }
        }
      }

      &.ul-one-card {
        display: none;
      }

      @include mq($from: desktop) {
        display: none;
      }
    }
  }

  .wrap {
    background-color: $pink-10;
    width: 100%;

    &.background {
      background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNDc0IiBoZWlnaHQ9IjM2NjQiIHZpZXdCb3g9IjAgMCAzNDc0IDM2NjQiPgogICAgPHBhdGggZmlsbD0iI0ZGRDZDRSIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMjM4MS45MTQgMjA1MC42MTNjNDA0Ljg5MiAwIDc2MC4zMzIgMjU5LjYyNiA3NjAuMzMyIDc2MC4zMzIgMCAzNS4wMjkgMCA3NS41NzEtNS4yMDggMTM0LjY0NmwtLjk3NCAxMC42MkgxOTgwLjExM2MyNC43MjYgMjA3LjA4MyAyMDcuMDgyIDMyMS40NDIgNDExLjA3MyAzMjEuNDQyIDE5MS42MjkgMCAzMzAuNzE0LTg5LjYzMyAzOTguNzEtMTk0LjcybDMxNS4yNiAyMzQuOUMyOTYyLjk4IDM1MjQuOTE1IDI3MTIuNjI3IDM2NjQgMjM4OC4wOTYgMzY2NGMtNDYwLjUyNyAwLTgxOS4wNTctMzE4LjM1LTgxOS4wNTctODA2LjY5MyAwLTQ1Ny40MzYgMzQzLjA3Ni04MDYuNjk0IDgxMi44NzUtODA2LjY5NHptLTEyLjM2MyAzNDkuMjU4Yy0xNTcuNjMgMC0zMzMuODA0IDgwLjM2LTM3My45ODQgMjY4Ljg5OGg3MjMuMjQyYy0zNy4wOS0xODIuMzU2LTE5MS42MjgtMjY4Ljg5OC0zNDkuMjU4LTI2OC44OTh6TTEzNjguNjE0IDBsNTg3Ljg0MiAxMDE4LjE3M2MyNDEuOTczIDQxOS4xMDggMTEyLjY3NyA4NTYuODI3LTI4NS4xMiAxMDg2LjQ5NS00MDIuNTM0IDIzMi40MDMtODQxLjUyMSAxMjIuNzgzLTEwODMuNDk0LTI5Ni4zMjVMMCA3OTAuMTdsMzQzLjMzNy0xOTguMjI2IDU5MC41NzcgMTAyMi45MDhjMTI4LjUwNSAyMjIuNTc4IDM0Mi4zOTYgMjc1Ljg4NyA1NDYuMDMgMTU4LjMxOCAyMDMuNjM1LTExNy41NjggMjY0LjQxNC0zMjkuNDU4IDEzNS45MDktNTUyLjAzNWwtNTkwLjU3Ny0xMDIyLjkxTDEzNjguNjE0IDB6bTE0NDguNjI0IDYxOC4xNTZjMzYxLjk3OCAwIDY1Ni41NTMgMjg3LjA4NiA2NTYuNTUzIDY1MS41NiAwIDM2NC40NzQtMjk0LjU3NSA2NTEuNTYtNjU2LjU1MyA2NTEuNTZzLTY1Ni41NTMtMjg3LjA4Ni02NTYuNTUzLTY1MS41NmMwLTM2NC40NzQgMjk0LjU3NS02NTEuNTYgNjU2LjU1My02NTEuNTZ6bTAgMzE5LjUzOWMtMTc5Ljc0IDAtMzEyLjA1IDEzOS43OTgtMzEyLjA1IDMzMi4wMiAwIDE5Mi4yMjQgMTMyLjMxIDMzMi4wMjIgMzEyLjA1IDMzMi4wMjIgMTc5Ljc0MSAwIDMwOS41NTQtMTM5Ljc5OCAzMDkuNTU0LTMzMi4wMjFzLTEyOS44MTMtMzMyLjAyMS0zMDkuNTU0LTMzMi4wMjF6Ii8+Cjwvc3ZnPgo=');
      background-repeat: no-repeat;

      @include mq($until: desktop) {
        background-size: cover;
      }
    }

    .subscription-main {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      &-dark {
        flex-direction: column;
      }
    }

    footer {
      margin-block-start: spacing(9);
      padding-block-end: 8.9rem;
      text-align: center;
      color: $purple-50;

      .footer-description {
        margin-block-end: spacing(2);
        font-weight: 600;
        color: $purple-40;
      }
    }
  }
</style>

<nav aria-label="Select subscription">
  <ul
    class="navigation"
    class:show={showNavbar(wrapper, yScrolled)}
    class:ul-one-card={oneSubscriptionCard}
  >
    {#each data.firstRow.productGroups as subscription, i}
      <li on:click={goToActiveCard(cards[i])}>
        <a
          href={`#${subscription.name}`}
          value={subscription.id}
          class:active={isCardActive(cards[i], yScrolled)}
          >{getTranslation(subscription.informationKeys, 'description.title.v2')}</a
        >
      </li>
    {/each}
  </ul>
</nav>
<div
  class="wrap"
  bind:this={wrapper}
  id="subscriptionSelectionComponent"
  class:background
  dir={isRTL ? 'rtl' : null}
>
  <div
    class:subscription-main={oneSubscriptionCard}
    class:subscription-main-dark={showDarkBackground}
  >
    <SubscriptionSelectionMain data={subscriptionData} bind:cards {componentInformationKeys} />
  </div>
  <footer>
    <p class="footer-description">
      {getTranslation(componentInformationKeys, 'priceplans.question.text')}
    </p>
    <TextButton
      arrow="inlineEnd"
      center="true"
      href={getTranslation(componentInformationKeys, 'priceplans.faq.url')}
      target="_blank"
      rel="noopener"
    >
      {getTranslation(componentInformationKeys, 'priceplans.faq.text')}
    </TextButton>
  </footer>
</div>
<svelte:window bind:scrollY={yScrolled} />
